import type { AxiosRequestConfig, AxiosRequestHeaders, AxiosResponse } from 'axios'

import { axiosResponse } from '@rentspree/axios'
import axios from 'axios'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'

import { authService } from 'auth'
import env from 'env'

import { handleAuthorization } from './api-handler'

type AxiosResponseInterceptor = (res: AxiosResponse) => AxiosResponse['data']

const axiosResponseInterceptor: AxiosResponseInterceptor = axiosResponse.response

const timestampConfig = () => ({ params: { t: new Date().getTime() } })

const requestInterceptor = async (config: AxiosRequestConfig): Promise<AxiosRequestConfig> => {
  const headers = get(config.headers, 'headers', {}) as AxiosRequestHeaders

  if (config.method && config.method.toUpperCase() === 'POST') {
    headers['Content-Type'] = 'application/json'
  }

  const accessToken = await authService.getAccessToken()

  if (!isEmpty(accessToken) && typeof accessToken === 'string') {
    headers.Authorization = `Bearer ${accessToken}`
  }

  return { ...config, headers, ...timestampConfig() }
}

const draftedListingAPIInstance = axios.create({
  baseURL: `${env.API_URL}`,
})

const publicListingAPIInstance = axios.create({
  baseURL: `${env.API_URL}`,
})

const reviewListingAPIInstance = axios.create({
  baseURL: `${env.API_URL}`,
})

const rcmApiInstance = axios.create({
  baseURL: env.RCM_API_BASE_URL,
})

const userApiInstance = axios.create({
  baseURL: env.USER_API_BASE_URL,
})

const publicMessagingApiInstance = axios.create({
  baseURL: `${env.USER_API_URL}/api/v2/message`,
})

const messagingApiInstance = axios.create({
  baseURL: `${env.USER_API_URL}/api/v2/user/messaging`,
})

draftedListingAPIInstance.interceptors.response.use(axiosResponseInterceptor, (error) =>
  handleAuthorization(error),
)

publicListingAPIInstance.interceptors.response.use(axiosResponseInterceptor, (error) =>
  handleAuthorization(error),
)

reviewListingAPIInstance.interceptors.response.use(axiosResponseInterceptor, (error) =>
  handleAuthorization(error),
)

rcmApiInstance.interceptors.response.use(axiosResponseInterceptor, (error) =>
  handleAuthorization(error),
)

userApiInstance.interceptors.response.use(axiosResponseInterceptor, (error) =>
  handleAuthorization(error),
)

publicMessagingApiInstance.interceptors.response.use(axiosResponseInterceptor, (error) =>
  handleAuthorization(error),
)

messagingApiInstance.interceptors.response.use(axiosResponseInterceptor, (error) =>
  handleAuthorization(error),
)

draftedListingAPIInstance.interceptors.request.use(requestInterceptor)
userApiInstance.interceptors.request.use(requestInterceptor)
reviewListingAPIInstance.interceptors.request.use(requestInterceptor)
messagingApiInstance.interceptors.request.use(requestInterceptor)

export {
  draftedListingAPIInstance,
  rcmApiInstance,
  userApiInstance,
  publicMessagingApiInstance,
  publicListingAPIInstance,
  messagingApiInstance,
  reviewListingAPIInstance,
}
